<template>
	<div id="app apps" class="bc-t-666 bc-f-14rp"  :oss='$route.meta.useKeepAlive'>

    <bv-view-transition id="runapptop" v-if="$route.meta.useKeepAlive && $route.meta.useKeepAlive == 'false'">
      <router-view ref='target'/>
    </bv-view-transition>

    <!--需要缓存的页面-->
    <bv-view-transition id="runappbottom"  v-else		>
      <keep-alive :exclude="config.view.keepAlive.exclude">
        <router-view ref='target'/>
      </keep-alive>
    </bv-view-transition>

	<!-- 圆形计时器 -->
	<!-- <div v-if="reFresh && !(browserIs.versions.iPad && isIOShide)" style="position: flex;left: 0; right: 0;top: 0; bottom: 0;overflow:hidden;z-index: -100;" v-cloak>
		<Timer ref="timer"></Timer>
	</div> -->

	<!-- 全局分享按钮 -->
	<div id="shareBox" @click="clickShare()" v-if="isShare"></div>
	<div id="tips-mask" v-show="isShow" @click="isShow = false">
		<img id="tips-mask-item" width="70%" height="48%" :src='`${staticPath}/Tips.png`' alt="慧联天下|大健康|首页">
		<img id="tips-mask-item" width="70%" height="15%" :src='`${staticPath}/Tips2.png`' alt="慧联天下|大健康|首页">
	</div>

		<!-- 底部导航 -->
		<w-tab-bar></w-tab-bar>

		<!-- 图片预览的组件 -->
		<blue-photo-swipe></blue-photo-swipe>

	</div>
</template>

<script>
import Timer from './components/wap/w-timer/w-timer';
import {login} from "$assets/js/login";
import './assets/js/shareBox.js'
import { isIOShide, browserIs } from '$assets/js/browser_type';

	export default {
		name: 'app',
		data() {
			return {
				reFresh: '',
				isShow: false,
        isShare: true,
        isIOShide,
        browserIs,
			}
		},
		computed:{
			key(){
				return this.$route.name ? this.$route.name+new Date() : this.$route+new Date()
			},
			staticPath(){
				return `${this.config.path.static}/img/home`;
			}
		},
		components: {
			Timer
		},
		watch:{
			'$route.path': {
				// 监听全局的计时器
				handler: function(newPath, oldPath){
					console.log(newPath,"reFresh")
					if(newPath == '/students') {
						this.isShare = false;
					} else {
						this.isShare = true;
					}
					if(this.$route.meta.timeBar) {
						// 判断是否是一点百通进来的
						if(this.$route.query.lifets || newPath == "/home/class_details") {
							this.reFresh = true;
						}
						if(newPath == "/disease/diseaseKown") {
							// console.log('在二级页面');
							if(this.$refs.timer) {
								this.$refs.timer.isRoll("paused");
							} else {
								return;
							}
						} else {
							// console.log('在当时页面');
							this.$refs.timer && this.$refs.timer.isRoll("running");
						}
					} else {
						// console.log('在首页');
						this.reFresh = false;
						return;
					}
				},
				// 深度观察监听
				deep: true
			},
			"$route.query.cont": {
				handler: function(newPath, oldPath){
					this.reFresh = false;
					if(this.$route.path == "/richdoor/details" && !this.$route.query.angel) {
						this.$nextTick(()=> {
							this.reFresh = true;
						})
					}
				}
			},
		},
		methods: {
			// 点击分享按钮
			clickShare() {
				var ua = window.navigator.userAgent.toLowerCase();
				if(ua.match(/MicroMessenger/i) == 'micromessenger') {
					// 判断是否是公众号
					this.isShow = true;
				} else if(this.config.device.isApp) {
					// 判断是否是APP
					var ele = document.getElementsByClassName('appshare')[0];
					// 判断是否登录
					if(!this.$store.getters.isLogin) {
						login();
						return false;
					} else {
						if(ele) {
							ele.click();
						} else {
							// 没有分享按钮使用默认分享
							console.log(this.$route.path);
							if(this.$route.path == '/sign') {
								this.$share({
									title: `签到`
								})
							} else if(this.$route.path == '/home/s_distribute') {
								this.$share({
									title: `驾照导航`
								})
							} else {
								this.$share({});
							}
						}
					}
				} else {
					this.$toast('请使用浏览器自带分享');
				}
			}
		}

	}
</script>

<style lang='scss'>
html,
	body {
		width: 100%;
		height: 100%;
	}
	[v-cloak] {
		display: none;
	}
	/*阿里字体图标*/
	@import url("//at.alicdn.com/t/font_1522064_1y57zee6q6s.css");

	//swipe 默认样式
	.swiper-pagination .swiper-pagination-bullet-active {
		background-color: $color-base !important;
	}
	#shareBox {
		width: 40px;
		height: 40px;
		background: url($base-url + "/img/home/shart1.png") no-repeat;
  		background-size: 100% 100%;
		position: absolute;
		top: 60%;
		right: 2%;
		z-index: 1000;
	}
	.shareB {
		position: absolute;
		top: 60%;
		right: 2%;
	}
	#tips-mask {
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		background-color: rgba(0, 0, 0, 0.7);
		z-index: 1001;
	}
	#tips-mask-item {
		float: right;
	}
</style>
